import API from '../utils/request'

export function getCustomerTagMapping (data) {
  return API.postQuery('/management/customerTag/getCustomerTagMapping', data)
}

export function getCustomerInfoByLeadingIn (data) {
  return API.postQuery('/management/customerTag/getCustomerInfoByLeadingIn', data)
}
